import { defineComponent } from "vue";
import { mapState } from "pinia";

import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import TemplateInput from "../../../../../resources-vue/vue-custom-elements/TemplateInput/TemplateInput.vue";

import { useEditReferralHH } from "../../../store/useEditReferralHH";

export default defineComponent({
    components: {
        FormSection,
        TemplateInput
    },

    computed: {
        ...mapState(useEditReferralHH, {
            application: "currentApplication",
            referral: "referral",
            referralOptions: "referralOptions",
            accountId: "accountId",
            errors: "errors"
        })
    },

    methods: {
        handleCommentsChanged(result: any) {
            this.referral.Insurance.AdditionalBillingInfo.PayerComment = result;
        }
    }
});
